import EconomicCalendarTable from "@/ui-components/economic-calendar-table";

function EconomicCalendar() {
  return <EconomicCalendarTable bodyRowClassNames="text-xs font-medium text-gray-900 dark:text-gray-100" />;
}

export default EconomicCalendar;
